import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  ViewEncapsulation,
} from '@angular/core'
import { ICON_TYPE } from '@spartacus/storefront'
import { Observable } from 'rxjs'
import {
  GlobalMessageEntities,
  GlobalMessageType,
  GlobalMessageService,
} from '@spartacus/core'

@Component({
  standalone: false,

  selector: 'vs-global-message',
  templateUrl: './global-message.component.html',
  styleUrls: ['./global-message.component.scss'],
})
export class VsGlobalMessageComponent implements OnInit {
  iconTypes = ICON_TYPE

  messages$: Observable<GlobalMessageEntities>
  messageType: typeof GlobalMessageType = GlobalMessageType

  constructor(protected globalMessageService: GlobalMessageService) {}

  ngOnInit(): void {
    this.messages$ = this.globalMessageService.get()
    /* this.messages$.subscribe(result => {
      debugger;
    }); */
  }

  clear(type: GlobalMessageType, index: number): void {
    this.globalMessageService.remove(type, index)
  }
}
